import styled from 'styled-components';
import { fontFamilyHeading, dynamicFontSize } from './helpers/mixins';

export const Quote = styled.blockquote`
  ${fontFamilyHeading};
  ${dynamicFontSize(22, 32)};
  margin: 2em 0;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: left;
  color: #000000;

  &:after {
    content: '';
    display: block;
    margin-top: 40px;
    height: 1px;
    width: 150px;
    background-color: #979797;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/Quote.js